<div class="page-header">
    <div class="title-section">
        <h2 class="page-title">Gestion des rôles</h2>
        <p class="page-subtitle">Configurez les rôles utilisateurs de votre application</p>
    </div>
    <button (click)="openCreateDialog()" class="btn btn-primary btn-with-icon">
        <mat-icon aria-hidden="true">add</mat-icon>
        Nouveau rôle
    </button>
</div>

@if (errorMessage) {
<div class="alert alert-error mb-4">
    {{ errorMessage }}
    <button class="close-alert" (click)="errorMessage = ''">×</button>
</div>
}
@if (successMessage) {
<div class="alert alert-success mb-4">
    {{ successMessage }}
    <button class="close-alert" (click)="successMessage = ''">×</button>
</div>
}

<div class="card shadow-sm mb-4">
    <div class="search-bar">
        <div class="search-bar-content">
            <div class="search-input-wrapper">
                <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
                <input type="text" [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange($event)"
                    placeholder="Rechercher un rôle..." class="search-input">
            </div>
        </div>
    </div>
    <div class="table-responsive">
        <table class="modern-table">
            <thead>
                <tr>
                    <th>Nom du rôle</th>
                </tr>
            </thead>
            <tbody>
                @for (role of roles; track role.id) {
                <tr class="clickable-row" (click)="openEditDialog(role)">
                    <td class="font-bold">
                        <div class="name-with-icon">
                            <mat-icon class="role-icon" aria-hidden="true">security</mat-icon>
                            {{ role | roleFormat }}
                        </div>
                    </td>
                </tr>
                } @empty {
                <tr class="empty-row">
                    <td colspan="1">
                        <div class="empty-state">
                            <mat-icon class="empty-icon" aria-hidden="true">security</mat-icon>
                            <p>Aucun rôle configuré</p>
                        </div>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>
    <mat-paginator [length]="totalElements()" [pageSize]="size()" [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="onPageChange($event)" aria-label="Sélectionner la page">
    </mat-paginator>
</div>